<template>
  <div class="layout-slider-template">
    <div class="nav-container">
      <div
        v-for="(item, index) in sliderMenuList"
        :key="index"
        class="nav-item"
        @mouseover="item.isHover = true"
        @mouseout="item.isHover = false"
        :class="{
          'is-new': item.isNew,
        }"
        @click="handleNavItemClick(item)"
      >
        <router-link
          class="nav-menu"
          :to="{ path: item.path }"
          v-if="item.path !== '/question-bank/index'"
        >
          <img
            :src="
              item.isHover || $route.path === item.path
                ? item.hoverIcon
                : item.icon
            "
          />
          {{ item.name }}
        </router-link>
        <span class="nav-menu" v-else>
          <img
            :src="
              item.isHover || $route.path === item.path
                ? item.hoverIcon
                : item.icon
            "
          />
          {{ item.name }}
        </span>
        <img
          src="../../../assets/images/laoshibang/new_tab.png"
          alt=""
          v-if="item.isNew"
          class="new-tab"
        />
      </div>
      <div
        class="item-vip"
        :style="{
          backgroundImage: `url(${myUrl})`,
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
        }"
        v-if="inviteStatus === 1"
        @click="openActivity"
      />
    </div>
    <div>
      <ActivityVip
        :dialogVipVisible="dialogVipVisible"
        :id="inviteId"
        :token="inviteToken"
        :actUrl="actUrl"
        @closePayActivity="closePayActivity"
      >
      </ActivityVip>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import sensors from "sa-sdk-javascript";
import ActivityVip from "@/components/activityVipDialog/index.vue";
import { getInviteInfo } from "@/api/invite";
import { getTikuLink } from "@/api/org";
import { getLocalToken } from "@/utils/token";
import sObserver from "@/utils/simpleObserver";

export default {
  name: "LayoutSlider",
  components: {
    ActivityVip,
  },
  data() {
    return {
      dialogVipVisible: false,
      inviteStatus: 1,
      inviteId: 0,
      inviteToken: "",
      actUrl: "",
      myUrl: "",
    };
  },
  computed: {
    ...mapGetters(["userId", "org", "userInfo", "abTestInfo"]),
    noOrg() {
      return (
        !this.userInfo ||
        !this.userInfo.orgList ||
        !this.userInfo.orgList.length
      );
    },
    // 获取AB测试信息，优先从store获取，fallback到localStorage
    effectiveAbTestInfo() {
      if (this.abTestInfo && Object.keys(this.abTestInfo).length > 0) {
        return this.abTestInfo;
      }
      // 如果store中没有，尝试从localStorage获取
      try {
        const stored = localStorage.getItem("abTestInfo");
        return stored ? JSON.parse(stored) : { strategy: "A" };
      } catch (e) {
        return { strategy: "A" };
      }
    },
    sliderMenuList() {
      const allMenuItems = [
        {
          icon: require("@/assets/images/laoshibang/home-icon.png"),
          hoverIcon: require("@/assets/images/laoshibang/home-icon-hover.png"),
          isHover: false,
          code: "CHAT",
          path: "/home/index",
          name: "首页",
          pathName: "首页",
          ename: "",
          query: "",
          isNew: false,
        },
        {
          icon:
            this.effectiveAbTestInfo &&
            this.effectiveAbTestInfo.strategy === "B"
              ? require("@/assets/images/laoshibang/home-icon.png")
              : require("@/assets/images/laoshibang/apps-no-select.png"),
          hoverIcon:
            this.effectiveAbTestInfo &&
            this.effectiveAbTestInfo.strategy === "B"
              ? require("@/assets/images/laoshibang/home-icon-hover.png")
              : require("@/assets/images/laoshibang/apps-select.png"),
          isHover: false,
          code: "apps",
          path:
            this.effectiveAbTestInfo &&
            this.effectiveAbTestInfo.strategy === "B"
              ? "/home/index"
              : "/apps/index",
          name:
            this.effectiveAbTestInfo &&
            this.effectiveAbTestInfo.strategy === "B"
              ? "首页"
              : "应用",
          pathName:
            this.effectiveAbTestInfo &&
            this.effectiveAbTestInfo.strategy === "B"
              ? "首页"
              : "应用",
          ename: "",
          query: "",
          isNew: false,
        },
        {
          icon: require("@/assets/images/laoshibang/chat-icon.png"),
          hoverIcon: require("@/assets/images/laoshibang/chat-icon-hover.png"),
          isHover: false,
          code: "APPLICATION",
          path: "/chat/index",
          name: "会话",
          pathName: "会话",
          ename: "",
          query: "",
          isNew: false,
        },
        {
          icon: require("@/assets/images/laoshibang/bank-icon.png"),
          hoverIcon: require("@/assets/images/laoshibang/bank-icon-hover.png"),
          isHover: false,
          code: "APPLICATION",
          path: "/question-bank/index",
          name: "校本题库",
          pathName: "校本题库",
          ename: "",
          query: "",
          customClass: "question-bank",
          isNew: true,
        },
        {
          icon: require("@/assets/images/laoshibang/user1-icon.png"),
          hoverIcon: require("@/assets/images/laoshibang/user1-icon-hover.png"),
          isHover: false,
          code: "APPLICATION",
          path: "/my/index",
          name: "我的",
          pathName: "我的",
          ename: "",
          query: "",
          isNew: false,
        },
      ];

      // 根据条件过滤菜单项
      return allMenuItems.filter((item) => {
        // 如果没有组织信息，隐藏校本题库
        if (this.noOrg && item.path === "/question-bank/index") {
          return false;
        }
        // 如果是B策略，隐藏原首页（根据code区分）
        if (
          item.code === "CHAT" &&
          this.effectiveAbTestInfo &&
          this.effectiveAbTestInfo.strategy === "B"
        ) {
          return false;
        }
        return true;
      });
    },
  },
  watch: {
    // 监听 userId 变化
    userId(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.getInviteInfo();
      }
    },
  },
  mounted() {
    // 初始化时调用
    this.getInviteInfo();
  },
  methods: {
    // 获取邀请信息
    getInviteInfo() {
      getInviteInfo()
        .then((res) => {
          console.log(res.data);
          this.actUrl = res.data.sidebarJumpUrl;
          const urlObj = new URL(res.data.sidebarJumpUrl);
          const searchParams = new URLSearchParams(urlObj.search);
          this.inviteId = searchParams.get("id");
          this.inviteToken = searchParams.get("token");
          this.inviteStatus = res.data.status;
          this.myUrl = res.data.sidebarUrl;
        })
        .catch((error) => {
          console.error("获取邀请信息失败:", error);
        });
    },
    // 打开活动弹框
    openActivity() {
      sensors.track("sidebar_invite_click");
      if (!getLocalToken("tal_token")) {
        return sObserver.fire("laoshibang-login");
      }
      this.getInviteInfo();
      this.dialogVipVisible = true;
    },
    // 关闭活动弹框
    closePayActivity() {
      this.dialogVipVisible = false;
    },
    handleNavItemClick(item) {
      if (item.path !== "/question-bank/index") {
        return;
      }
      getTikuLink({
        orgId: this.org.orgId,
      }).then((res) => {
        if (res.code === 200) {
          const a = document.createElement("a");
          a.style.display = "none";
          a.href = res.data.url;
          a.target = "_blank";
          a.click();
        } else {
          this.$message.error(res.msg);
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.layout-slider-template {
  padding: 0px 0px 0px 40px;
  width: 200px;
  height: 100%;
  background: var(--layout-slider-background-color);
  position: relative;
}

.nav-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-items: center;
  margin-top: 16px;
}

.nav-item {
  width: 140px;
  height: 48px;
  flex-shrink: 0;
  border-radius: 10px;
  text-align: center;
  line-height: 48px;
  margin-bottom: 20px;
  color: #7f8aa5;
  border: 10px;
  text-align: center;
  position: relative;
  &.is-new {
    .new-tab {
      position: absolute;
      right: -9px;
      top: -7px;
      width: 20px;
      height: 20px;
      display: none;
    }
  }
  &:hover {
    cursor: pointer;
    background: #e2ebff;
    color: #0d70ed;
    &.is-new .new-tab {
      display: block;
    }
  }

  &.question-bank {
    img {
      width: 15px;
      height: 18px;
    }
  }
}

.nav-menu {
  width: 140px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 10px;
  user-select: none;
  font-family: "PingFang SC";
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 48px; /* 146.667% */
  cursor: pointer;
  img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
    margin-left: 28px;
  }
  .iconfont {
    color: var(--route-icon-color);
  }
  &.is-actived,
  &.router-link-exact-active {
    background: #e2ebff;
    color: #0d70ed;
  }
}

.item-vip {
  position: absolute;
  width: 120px;
  height: 62px;
  background-size: cover;
  cursor: pointer;
  border-radius: 10px;
  bottom: 154px;
}
</style>
